/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components

function QuotationLayout({ children }) {
    return (
        <PageLayout>
            <DefaultNavbar
                action={{
                    type: "external",
                    route: "https://creative-tim.com/product/material-dashboard-react",
                    label: "free download",
                    color: "dark",
                }}
            />

            <MDBox px={4} width="100%" height="100vh" mx="auto" py={4} >
                <Grid container spacing={1} justifyContent="end" height="100%" >
                    <Grid item xs={12} sm={12} md={5} lg={12} xl={12} >
                        {children}
                    </Grid>
                </Grid>
            </MDBox>
            {/* <Footer light /> */}
        </PageLayout>
    );
}

// Typechecking props for the BasicLayout
QuotationLayout.propTypes = {
    children: PropTypes.node.isRequired,
};

export default QuotationLayout;
